import React, { useRef, useState } from 'react';
import styles from './AdminMobileEventRegister.module.css';
import useCustomAdminMobileMove from '../hooks/useCustomAdminMobileMove';
import { validateInputs } from 'shared/utils/Utils';
import { toast } from "react-toastify";
import Container from 'layouts/container/Container';
import { mainBgColor, mainPadd, pageCommonGap1, pageCommonPadd2, pageH1FontSize, registerFontSize, registerGap1, registerGap2, registerHeight } from '../constraints/AdminConst';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import FlexChild from 'layouts/flex/FlexChild';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import backIcon from 'routes/vendorRe/images/back_icon.png';
import AdminMobileContentBox from '../components/common/AdminMobileContentBox';
import P from 'components/P';
import InputImage from 'components/inputs/image/InputImage';
import InputText from 'components/inputs/signUp/InputText';
import { textFormat } from "InitialData/regExp";
import { CFormSelect } from '@coreui/react';

// 노출 위치 테스트 데이터
const expoLocation = [
    {
        location: "home",
        locationExp: "홈화면",
    },
    {
        location: "topBanner",
        locationExp: "상단배너",
    },
    {
        location: "bottomBanner",
        locationExp: "하단배너",
    },
];

// 노출 페이지 테스트 데이터
const expoPage = [
    {
        page: "1",
        pageExp: "1 페이지",
    },
    {
        page: "2",
        pageExp: "2 페이지",
    },
    {
        page: "3",
        pageExp: "3 페이지",
    },
];

const AdminMobileEventRegister = () => {
    const inputs = useRef([]);
    const [event, setEvent] = useState();
    const [selectedExpoLocation, setSelectedExpoLocation] = useState();
    const [selectedExpoPage, setSelectedExpoPage] = useState();
    const {moveToBack} = useCustomAdminMobileMove();

    let data = {
        eventId: "root",
        eventImg: "",
        eventTitle: "",
        eventStartDate: "",
        eventEndDate: "",
        eventLocation: selectedExpoLocation === "" ? null : selectedExpoLocation,
        eventPage: selectedExpoPage === "" ? null : selectedExpoPage,
    };

    const handleLocationChange = (event) => {
        // 여기에서 선택된 노출 위치를 사용할 수 있습니다.
        
        setSelectedExpoLocation(event.target.value);
    };

    const handlePageChange = (event) => {
        // 여기에서 선택된 노출 페이지를 사용할 수 있습니다.
        
        setSelectedExpoPage(event.target.value);
    };

    // 이벤트 등록 버튼 클릭 함수
    const onClick = () => {
        // 초기화 데이터
        

        validateInputs(inputs.current).then((result) => {
            if(result.isValid) {
                data.eventImg = inputs.current[0].getValue();
                data.eventTitle = inputs.current[1].getValue();
                data.eventStartDate = inputs.current[2].getValue();
                data.eventEndDate = inputs.current[3].getValue();

                // validate 이후 데이터 확인
                
            }else {
                toast.error(`${inputs.current[result.index].getName()} 항목을 확인해주세요`, {
                    autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                });
            }
        });
    };

    return (
        <Container height={registerHeight}>
            <VerticalFlex gap={pageCommonGap1} backgroundColor={mainBgColor} padding={pageCommonPadd2}>
                <FlexChild height={"initial"} padding={mainPadd}>
                    <HorizontalFlex>
                        <FlexChild width="auto">
                            <img onClick={() => moveToBack()} className={styles.backIcon} src={backIcon} alt='뒤로 가기 버튼' />
                        </FlexChild>
                        <FlexChild justifyContent="center">
                            {/* H1 헤더 */}
                            <P size={pageH1FontSize}>이벤트 등록</P>
                        </FlexChild>
                    </HorizontalFlex>
                </FlexChild>
                <FlexChild padding={mainPadd}>
                    <AdminMobileContentBox flexStart>
                        <VerticalFlex gap={registerGap1}>
                            <FlexChild>
                                <VerticalFlex gap={registerGap2}>
                                    <FlexChild alignItems="flex-start">
                                        <P size={registerFontSize}>이벤트 제목</P>
                                    </FlexChild>
                                    <FlexChild>
                                        <InputImage ref={el => (inputs.current[0] = el)} name={"상품 라벨"} path={"product/"} labelWidth={0} cropWidth={200} cropHeight={200} value={event && event.image ? event.image : ""} maxSizeMb={1} />
                                    </FlexChild>
                                    <FlexChild alignItems="flex-start">
                                        <InputText ref={el => (inputs.current[1] = el)} placeHolder={"이벤트 제목을 입력하세요."} regExp={[textFormat]} />
                                    </FlexChild>
                                </VerticalFlex>
                            </FlexChild>
                            <FlexChild>
                                <VerticalFlex gap={registerGap2}>
                                    <FlexChild alignItems="flex-start">
                                        <P size={registerFontSize}>기간 설정</P>
                                    </FlexChild>
                                    <FlexChild>
                                        <HorizontalFlex gap={registerGap2}>
                                            <FlexChild>
                                                <InputText ref={el => (inputs.current[2] = el)} placeHolder={"이벤트 시작일"} regExp={[textFormat]} />
                                            </FlexChild>
                                            <FlexChild width="auto">
                                                <P>-</P>
                                            </FlexChild>
                                            <FlexChild>
                                                <InputText ref={el => (inputs.current[3] = el)} placeHolder={"이벤트 종료일"} regExp={[textFormat]} />
                                            </FlexChild>
                                        </HorizontalFlex>
                                    </FlexChild>
                                </VerticalFlex>
                            </FlexChild>
                            <FlexChild>
                                <VerticalFlex gap={registerGap2}>
                                    <FlexChild alignItems="flex-start">
                                        <P size={registerFontSize}>노출 위치</P>
                                    </FlexChild>
                                    <FlexChild alignItems="flex-start">
                                        <CFormSelect onChange={handleLocationChange}>
                                            <option value={""}>선택하세요</option>
                                            {expoLocation && expoLocation.map((loca) => (
                                                <option key={loca.location} value={loca.location}>
                                                    {loca.locationExp}
                                                </option>
                                            ))}
                                        </CFormSelect>
                                    </FlexChild>
                                </VerticalFlex>
                            </FlexChild>
                            <FlexChild>
                                <VerticalFlex gap={registerGap2}>
                                    <FlexChild alignItems="flex-start">
                                        <P size={registerFontSize}>노출 페이지</P>
                                    </FlexChild>
                                    <FlexChild alignItems="flex-start">
                                        <CFormSelect onChange={handlePageChange}>
                                            <option value={""}>선택하세요</option>
                                            {expoPage && expoPage.map((page) => (
                                                <option key={page.page} value={page.page}>
                                                    {page.pageExp}
                                                </option>
                                            ))}
                                        </CFormSelect>
                                    </FlexChild>
                                </VerticalFlex>
                            </FlexChild>
                        </VerticalFlex>
                    </AdminMobileContentBox>
                </FlexChild>
                <FlexChild height="initial" padding={mainPadd}>
                    <div className={styles.regiBtn} onClick={onClick}>
                        <span>등록하기</span>
                    </div>
                </FlexChild>
            </VerticalFlex>
        </Container>
    );
};

export default AdminMobileEventRegister;